import {useIntl} from 'react-intl'

export default function usePostalCodeFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        postalCode: {
            name: `${prefix}postalCode`,
            type: 'text',
            defaultValue: '',
            placeholder: formatMessage({
                defaultMessage: 'Postal Code',
                id: 'use_address_fields.label.postal_code'
            }),
            rules: {
                required: formatMessage({
                    defaultMessage: 'Enter a valid postcode',
                    id: 'use_postal_code_fields.error.enter_postal_code'
                }),
                pattern: {
                    value: /^([A-Z][A-HJ-Y]?\d[A-Z\d]? \d[A-Z]{2}|GIR ?0A{2})$/i,
                    message: formatMessage({
                        defaultMessage: 'Enter a valid postcode',
                        id: 'use_postal_code_fields.error.enter_postal_code'
                    })
                }
            },
            error: errors[`${prefix}postalCode`],
            control
        }
    }

    return fields
}
